import { MultiSelect, MultiSelectProps } from '@mantine/core';

import { useGetInterestSectorsQuery } from '@api/interestSector.api';
import { uniqueByName } from '@utils/strings';

export default function InterestSectorSelector(props: MultiSelectProps) {
  const { data = [], isLoading } = useGetInterestSectorsQuery();

  return (
    <MultiSelect
      label="Settori di interesse"
      placeholder={
        props.value && props.value.length !== 0
          ? undefined
          : 'Seleziona i settori di interesse'
      }
      data={uniqueByName(data).map((sector) => ({
        label: sector.name,
        value: sector.name,
      }))}
      disabled={isLoading}
      {...props}
    />
  );
}
